import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const OrderDispatchedBadge = (props: BadgeProps): React.ReactElement => (
  <Badge
    {...props}
    icon={"PACKAGE_VARIANT_CLOSED"}
    className={twMerge("bg-purple-100 text-purple-700", props.className)}
  >
    Order dispatched
  </Badge>
);
